import router from './router'
import store from './store'
import user from './store/modules/user';
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth' // 从cookie中获取token
import Vue from "vue";


const whiteList = ['/login','/register'] // 不需要重定向名单



router.beforeEach(((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
}))

/**
 * 根据权限控制按钮的显示隐藏
 * ===========================================
 * */
// 是否有权限
const hasPermission = userPermission => {
  let userPermissionList = Array.isArray(userPermission) ? userPermission : [userPermission];
  // 当前用户的权限列表
  let permissionList = store.getters.roles;
  return userPermissionList.some(e => permissionList.includes(e));
};
// 指令
Vue.directive('has', {
  inserted: (el, binding, vnode) => {
    if (!hasPermission(binding.value)) {
      // 将节点进行移除
      el.parentNode.removeChild(el);
    }
  }
});
// 全局判断方法
Vue.prototype.$_has = hasPermission;



// WEBPACK FOOTER //
// ./src/permission.js